import React, { Component } from 'react';
import Button from '../button/Button';

export default class PrimaryButton extends Component {
	render() {
		return (
			<Button bg="darkblue" color="white" {...this.props}>
				{this.props.children}
			</Button>
		);
	}
}
